import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { formatDate } from '@tallyframe/core';
import { BrandLine } from './ReportHeader.js';
/**
 * The PDF cover (spec §4). Three presets carry the same fields in a
 * preset-owned DOM order. Classic with the default theme is exactly the cover
 * `PrintReport` rendered before theming.
 */
export function PrintCover(props) {
    switch (props.theme.cover) {
        case 'banner':
            return _jsx(BannerCover, { ...props });
        case 'centered':
            return _jsx(CenteredCover, { ...props });
        default:
            return _jsx(ClassicCover, { ...props });
    }
}
function Title({ definition }) {
    return _jsx("h1", { className: "tf-print-title", children: definition.title });
}
function Subtitle({ definition }) {
    return definition.subtitle ? _jsx("p", { className: "tf-print-subtitle", children: definition.subtitle }) : null;
}
function Meta(props) {
    const { definition, dataAsOf, issuedAt, locale } = props;
    if (!definition.print.includeCoverSummary)
        return null;
    return (_jsxs("dl", { className: "tf-print-meta", children: [_jsx("dt", { children: "Data as of" }), _jsx("dd", { children: formatDate(dataAsOf, locale) }), issuedAt ? (_jsxs(_Fragment, { children: [_jsx("dt", { children: "Issued" }), _jsx("dd", { children: formatDate(issuedAt, locale) })] })) : null] }));
}
function brandLine(props) {
    return (_jsx(BrandLine, { brand: props.brand, preparedFor: props.definition.preparedFor, preparedBy: props.theme.preparedBy || undefined }));
}
function ClassicCover(props) {
    return (_jsxs("header", { className: "tf-print-cover", children: [brandLine(props), _jsx(Title, { definition: props.definition }), _jsx(Subtitle, { definition: props.definition }), _jsx(Meta, { ...props })] }));
}
function BannerCover(props) {
    return (_jsxs("header", { className: "tf-print-cover tf-print-cover--banner", children: [_jsxs("div", { className: "tf-print-cover-band", children: [_jsx(Title, { definition: props.definition }), _jsx(Subtitle, { definition: props.definition })] }), brandLine(props), _jsx(Meta, { ...props })] }));
}
function CenteredCover(props) {
    const { brand, definition, theme } = props;
    const [failedUrl, setFailedUrl] = useState(null);
    const showLogo = Boolean(brand.logoUrl) && brand.logoUrl !== failedUrl;
    const prepared = [
        definition.preparedFor ? `Prepared for ${definition.preparedFor}` : null,
        theme.preparedBy ? `Prepared by ${theme.preparedBy}` : null
    ].filter(Boolean);
    return (_jsxs("header", { className: "tf-print-cover tf-print-cover--centered", children: [showLogo ? (_jsx("img", { className: "tf-brand-logo", src: brand.logoUrl ?? undefined, alt: brand.name, onError: () => setFailedUrl(brand.logoUrl) })) : null, brand.name ? _jsx("span", { className: "tf-brand-name", children: brand.name }) : null, _jsx(Title, { definition: definition }), _jsx(Subtitle, { definition: definition }), prepared.length > 0 ? _jsx("p", { className: "tf-print-cover-prepared", children: prepared.join(' · ') }) : null, _jsx(Meta, { ...props }), _jsx("div", { className: "tf-print-cover-rule", "aria-hidden": "true" })] }));
}
//# sourceMappingURL=PrintCover.js.map